import React from 'react';

import { type ImageProps, type StaticImageData } from 'next/image';
import Link from 'next/link';

import HomeIcon from '@mui/icons-material/Home';
import { Box, Button, Container, type ContainerProps } from '@mui/material';

import { sizes } from '@client/constants/sizes';
import ErrorImage from '@public/images/error-image-alien.png';

import SimplePageComponent from './SimplePageComponent';

type Props = {
  containerProps?: ContainerProps;
  title?: React.ReactNode;
  body?: React.ReactNode;
  imageSrc?: string | StaticImageData;
  imageAlt?: string;
  imageProps?: Partial<ImageProps>;
  buttons?: React.ReactNode | React.ReactNode[];
};

export default ({
  title = 'Er is iets fout gegaan!',
  body = 'Als dit probleem aanhoudt, aarzel niet om ons te contacteren.',
  imageSrc = ErrorImage,
  imageAlt = 'uh-oh',
  imageProps = { width: 583, height: 365 },
  buttons = (
    <Link href='/' passHref key={'back-to-dashboard'}>
      <Button size='medium' variant='contained' startIcon={<HomeIcon />}>
        {'Terug naar dashboard'}
      </Button>
    </Link>
  ),
  ...props
}: Props) => (
  <>
    <Container
      {...props}
      maxWidth={'md'}
      sx={{
        height: `calc(100% - ${sizes.navBarHeight} * 4)`,
        maxHeigth: 200,
        display: 'flex',
      }}>
      <Box sx={{ m: 'auto', p: 4 }}>
        <SimplePageComponent
          title={title}
          body={body}
          imageSrc={imageSrc}
          imageAlt={imageAlt}
          imageProps={imageProps}
          buttons={buttons}
        />
      </Box>
    </Container>
  </>
);
